module.exports = __webpack_public_path__ + "img/img_sample.2dee81c9.png";